import { RouteRecordRaw } from 'vue-router'
import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import RouteViewComponent from '../layouts/RouterBypass.vue'

const staticRoutes: Array<RouteRecordRaw> = [
  { path: '/', redirect: '/auth/login' },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      { name: 'login', path: 'login', component: () => import('../pages/auth/Login.vue') },
      { name: 'signup', path: 'signup', component: () => import('../pages/auth/Signup.vue') },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      { path: '', redirect: { name: 'login' } },
    ],
  },
  {
    name: 'admin-dashboard',
    path: '/',
    component: AppLayout,
    redirect: '/dashboard',
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'notifications',
        path: 'notifications',
        component: () => import('../pages/notifications/general/NotificationsPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'superadmin',
        path: 'superadmin',
        component: RouteViewComponent,
        children: [
          {
            name: 'menus',
            path: 'menus',
            component: () => import('../pages/superadmin/menus/MenuList.vue'),
            meta: { requiresAuth: true },
          },
        ],
      },
      // ⛳️ Semua group menu akan diinject di sini
    ],
  },
  { name: '404', path: '/404', component: () => import('../pages/404.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/auth/login' },
]

export default staticRoutes
